












































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import * as proxy from "@/lib/service-proxies/service-proxies";
import AppConsts from "@/lib/appconst";
import PagedFilterAndSortedRequest from "@/store/entities/page-request";
import pagelist from "@/components/pagelistcomponent";
@Component({
  components: {},
})
export default class suppliermanage extends pagelist {
  get prox() {
    return new proxy.UsdtTransactionServiceProxy();
  }
  input: proxy.UsdtTransactionPageInputDto =
    new proxy.UsdtTransactionPageInputDto();
  sub_id = 0;
  createOrEditShow = false;
  createrange = [];
  BalanceTypes = [];
  columns = [
    {
      type: "selection",
      width: 60,
      align: "center",
    },
   
    {
      title: "交易哈希",
      key: "txid",
    },
    {
      title: "收款",
      key: "to",
    },
    {
      title: "打款",
      key: "from",
    },
    {
      title: "交易时间",
      key: "transactionTime",
    },
    {
      title: "交易金额",
      slot: "value",
    },
    {
      title:'交易方式',
      slot:'method'
    },
  ];
  fetchDataList(
    request: PagedFilterAndSortedRequest,
    pageNumber: number,
    finishedCallback: Function
  ): void {
    this.input.skipCount = request.skipCount;
    this.input.maxResultCount = request.maxResultCount;
    this.input.sorting = request.sorting;
    this.prox.queryModelList(this.input).then((x) => {
      this.dataList = x.items;
      this.showPaging(x);
    });
  }
  exportrecord() {
    var ids = this.selectedDataItems.map((x) => {
      return x.id;
    });
    this.input.ids = ids;
    // this.prox.export(this.input).then((x) => {
    //   location.href =
    //     AppConsts.remoteServiceBaseUrl +
    //     '/File/DownloadTempFile?FileToken=' +
    //     x.fileToken +
    //     '&fileName=' +
    //     x.fileName +
    //     '&fileType=' +
    //     x.fileType;
    // });
  }
  getpage() {
    this.OnInit();
  }
  async created() {
    this.getpage();
  }
}
